import { Inbox, Mail, MessageCircle, Smartphone } from "lucide-react";

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { NotificacaoTesteCanal } from "@/services/api/notificacao-teste.service";

const CANAIS: { value: NotificacaoTesteCanal; label: string; icon: typeof Mail }[] = [
  { value: "EMAIL", label: "E-mail", icon: Mail },
  { value: "WHATSAPP", label: "WhatsApp", icon: MessageCircle },
  { value: "SMS", label: "SMS", icon: Smartphone },
  { value: "INBOX", label: "Hub Inbox", icon: Inbox },
];

interface CanalFieldProps {
  value: NotificacaoTesteCanal;
  onChange: (canal: NotificacaoTesteCanal) => void;
}

export function CanalField({ value, onChange }: CanalFieldProps) {
  return (
    <div className="space-y-2">
      <Label>Canal</Label>
      <Select value={value} onValueChange={(v) => onChange(v as NotificacaoTesteCanal)}>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {CANAIS.map(({ value: canal, label, icon: Icon }) => (
            <SelectItem key={canal} value={canal}>
              <span className="flex items-center gap-2">
                <Icon className="h-4 w-4" /> {label}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
